//@ts-nocheck
import { AdminTemplate, InputControl, SectorManagementForm } from '../../components';
import React, { useEffect, useState } from 'react';

export const SectorManagement = () => {

    const [currentSector, setCurrentSector] = useState(null as any);

    return <>
        <AdminTemplate
            headerProps={{ headerTitle: "Sektör Ayarları", hideAddButton: true }}
        >
            <SectorManagementForm />
        </AdminTemplate>
    </>;
};